import { SetStateAction, useState } from "react";
import { useCurrentUser, useCentralApi } from "hooks/shared";
import { WorkItem } from "./useWorkItem";

export interface BulkUpdateWorkItemValidationResult {
    userId: string;
    valid: boolean;    
    concurrency?: boolean;
    responsibilityId: number;
    workItemInstanceId: number;    
    resourceMissing?: boolean;
    successorTaskStatus?: boolean;
    userNotFoundInWorkItem?: boolean;    
    userNotInWorkSpace?: boolean;
    responsibilityNotInWorkItem?: boolean;
    statusTransitionPossible?: boolean;
    workItemStatusIsComplete?: boolean;
}

export interface GetSaveWorkItemResult {
    statusResponse: string,
    errorMessage: string,
    results: BulkUpdateWorkItemValidationResult[],
  }
  
type WorkItemResult = [
    GetSaveWorkItemResult | null,
    boolean,
    string | null,
    React.Dispatch<SetStateAction<GetSaveWorkItemResult | null>>,
    () => {}
];

type WISignature = (workItems: WorkItem[], TaskTrackingId?: string) => WorkItemResult;

const useSaveWorkItems: WISignature = (workItems, taskTrackingId) => {
    const [ result, setResult ] = useState<GetSaveWorkItemResult | null>(null);
    const [ error, setError ] = useState<string | null>(null);
    const [ loading, setLoading ] = useState<boolean>(false);    
    const user = useCurrentUser();
    const fetcher = useCentralApi(user);

        const controller = new AbortController();
        const saveWorkItems = async () => {            
            if (user && user.id_token && workItems && taskTrackingId) {
                setLoading(true);
                setResult(null);
                try {
                    var payload = {workItems: workItems, resources: [], taskTrackingId: taskTrackingId+'-'+user.profile.name}
                    const resp = await fetcher(`/api/v3/bulkupdate/workitem`, {
                        method: 'POST',
                        body: JSON.stringify(payload),
                        signal: controller.signal
                    });

                    if (!resp.ok) {
                        // RESPOND TO ERRORS
                    }

                    const data = await resp.json();
                    setResult(data);
                } catch (err) {
                    // TODO: 
                } finally {
                    setLoading(false);
                }
            } else {
                setLoading(true);
                setResult({
                    statusResponse: 'ok',
                    errorMessage: '',
                    results: [],
                });
                setLoading(false);
            }
        };

    return [
        result,
        loading,
        error,
        setResult,
        saveWorkItems
    ];
};

export default useSaveWorkItems;